module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/babel-runtime/core-js/get-iterator.js
 ** module id = 579
 ** module chunks = 0
 **/